// Shared helper: a pillar's `specialty` is a single comma-separated string.
// Splitting it into an array is required for filtering, display chips,
// and matching so that entries like
//   "Mirror-Based Therapy, Lifecoaching, NLP therapy"
// behave as multiple tags rather than one long label.
export function splitSpecialties(value) {
    if (!value || typeof value !== 'string') return [];
    return value
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
}
